export default __webpack_public_path__ + "static/media/logoprestapolis.7fad2cfc.png";